module.exports = __webpack_public_path__ + "static/media/optima-seguros-vest.c8209de8.svg";